import {estimateStatuses} from "../EstimateState";
import FilterUtil from "../../utils/common/FilterUtil";
import {
    EMPTY_CUSTOMER_FILTER,
    EMPTY_CUSTOMER_NUMBER_FILTER,
    EMPTY_HEADER_FILTER,
    EMPTY_MODEL_FILTER,
    EMPTY_ORDER_NUMBER_FILTER,
    EMPTY_PLAN_FILTER
} from "../OrderStatus";
import {matchEmptyOrIncludes} from "../../utils/common/matchEmptyOrIncludes";

export const OrderEconomicTableFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_ORDER_NUMBER_FILTER, options)
    },
    {
        "idFromColumnFilter": "hand-price",
        "id": "estimate",
        "filterFn": (estimate, filterValue) => FilterUtil.checkStatus(
            estimate?.basePrice?.handPrice === true || estimate?.baseJobPrice?.handPrice === true,
            filterValue
        )
    },
    {
        "idFromColumnFilter": "customer",
        "id": "customerName",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CUSTOMER_FILTER, options)
    },
    {
        "idFromColumnFilter": "header",
        "id": "header", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_HEADER_FILTER, options)
    },
    {
        "idFromColumnFilter": "models",
        "id": "estimate",
        "field": "modules",
        "filterFn": (value, filterValue, _enum, options) => {
            const names = (value || []).map((module) => module?.originalName).filter(Boolean)
            if (filterValue === EMPTY_MODEL_FILTER) {
                return names.length === 0
            }
            const needle = String(filterValue ?? '').toLowerCase()
            return names.some((name) => options?.exact
                ? name.toLowerCase() === needle
                : name === filterValue || name.toLowerCase().includes(needle))
        }
    },
    {
        "idFromColumnFilter": "numberCustomer",
        "id": "numberCustomer",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_CUSTOMER_NUMBER_FILTER, options)
    },
    {
        "idFromColumnFilter": "plan",
        "id": "plan", "field": "name",
        "filterFn": (value, filterValue, _enum, options) => matchEmptyOrIncludes(value, filterValue, EMPTY_PLAN_FILTER, options)
    },
    {
        "idFromColumnFilter": "baseTotalPrice",
        "id": "estimate", "field": "baseTotalPrice",
        "filterFn": (value, filterValue) => !value?.price ? "ожидание".includes(filterValue.toLowerCase()) : value?.price?.toFixed(2).includes(filterValue)
    }, {
        "idFromColumnFilter": "totalCostBasePrice",
        "id": "estimate", "field": "totalCostBasePrice",
        "filterFn": (value, filterValue) => !value?.price ? "ожидание".includes(filterValue.toLowerCase()) : value?.price?.toFixed(2).includes(filterValue)
    },
    {
        "idFromColumnFilter": "calculationTotalCostBasePrice",
        "id": "estimate", "field": "calculationTotalCostBasePrice",
        "filterFn": (value, filterValue) => !value?.price ? "ожидание".includes(filterValue.toLowerCase()) : value?.price?.toFixed(2).includes(filterValue)
    },

    {
        "idFromColumnFilter": "profitCalculationBaseTotalPrice",
        "id": "estimate", "field": "profitCalculationBaseTotalPrice",
        "filterFn": (value, filterValue) => !value?.price ? "ожидание".includes(filterValue.toLowerCase()) : value?.price?.toFixed(2).includes(filterValue)
    },
    {
        "idFromColumnFilter": "profitBaseTotalPrice",
        "id": "estimate", "field": "profitBaseTotalPrice",
        "filterFn": (value, filterValue) => !value?.price ? "ожидание".includes(filterValue.toLowerCase()) : value?.price?.toFixed(2).includes(filterValue)
    },
    {
        "idFromColumnFilter": "calculationGrossMargin",
        "id": "estimate", "field": "calculationGrossMargin",
        "filterFn": (value, filterValue) => !value ? "ожидание".includes(filterValue.toLowerCase()) : value?.price?.toFixed(2).includes(filterValue)
    },
    {
        "idFromColumnFilter": "grossMargin",
        "id": "estimate", "field": "grossMargin",
        "filterFn": (value, filterValue) => !value ? "ожидание".includes(filterValue.toLowerCase()) : value?.toFixed(2).includes(filterValue)
    },
    {
        "idFromColumnFilter": "estimateState",
        "id": "estimate", "field": "estimateState",
        "filterFn": (value, filterValue) => estimateStatuses[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "manufactured",
        "id": "manufactured",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
    {
        "idFromColumnFilter": "shipped",
        "id": "shipped",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },

    {
        "idFromColumnFilter": "dateOfReceipt",
        "id": "dateOfReceipt",
        "filterFn": (value, filterValue) => new Date(value).toLocaleDateString("en-GB").includes(filterValue)
    },
]
